//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import landingStyles from "@/components/mixins/landingStyles";
import ArrowCodeIcon from "@/assets/icons/arrows/ArrowCodeIcon.svg?inline";
import LandingImage from "@/components/landing/elements/LandingImage";
import SectionTools from "@/components/landing/elements/SectionTools";
import LandingText from "@/components/landing/elements/LandingText";

export default {
  name: "LandingSectionGallery",
  components: {
    LandingText,
    SectionTools,
    LandingImage,
    Swiper,
    SwiperSlide,
    ArrowCodeIcon,
  },
  mixins: [
    landingStyles
  ],
  props: {
    section: {
      type: Object,
      default: () => {
      }
    },
    editable: {
      type: Boolean,
      default: false,
    },
    currentIndex: {
      type: Number,
      default: 0
    },
  },
  data: () => {
    return {
      screenWidth: 0,
      showButtonNext: false,
      showButtonPrev: false,
      showTools: false,
      containerSize: {
        width: 0,
        height: 0
      },
    }
  },
  computed: {
    swiperOption() {
      return {
        init: false,
        updateOnWindowResize: true,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: !this.editable,
        breakpoints: {
          '768': {
            slidesPerView: 2,
          },
          '1200': {
            slidesPerView: 3,
          },
        }
      }
    },
    backgroundImage() {
      const imageId = this.section.styles.backgroundImage ?? ''

      return (imageId === '') ? '' : `${process.env.BACKEND_BASE_URL}/api/v2/landing/${imageId}/image`
    },
  },
  mounted() {
    if (this.editable)
      this.updateSectionSizes()
    this.$refs.gallerySlider.$swiper.init()
  },
  methods: {
    updateSectionSizes() {
      this.containerSize.width = this.$refs[`container_${this.section.id}`].clientWidth
      this.containerSize.height = this.$refs[`section_${this.section.id}`].clientHeight
    },
    updateSliderButton(swiper) {
      if (!this.editable) {
        this.showButtonNext = true
      }
      this.onSlideChange(swiper)
    },
    onSlideChange(swiper) {
      this.showButtonNext = !swiper.isEnd
      this.showButtonPrev = !swiper.isBeginning
    },
    changeSlide(prev = false) {
      if (prev)
        this.$refs.gallerySlider.$swiper.slidePrev()
      else
        this.$refs.gallerySlider.$swiper.slideNext()
    },
    updateSection() {
      this.updateSectionSizes()
      this.$store.dispatch('landing/updateSection', {section: this.section, index: this.currentIndex})
    },
  },
}
